/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

enum PublisherState {
  Initializing = 0,
  Offline = 1,
  Starting = 2,
  Publishing = 3,
  Recovering = 4,
  Reconnecting = 5,
  Stopped = 6,
  Unauthorized = 7,
  GeoRestricted = 8,
  GeoBlocked = 9,
  UnsupportedFeature = 10,
  NotFound = 11,
  ConfigurationError = 12,
  TransientConfigurationError = 13,
  ConnectionError = 14,
  ClientStartError = 15,
  Error = 16
}

export default PublisherState;